import { render, staticRenderFns } from "./zhubolist.vue?vue&type=template&id=6aba66d6"
import script from "./zhubolist.vue?vue&type=script&lang=js"
export * from "./zhubolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports